// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import patientPageImg from "src/assets/images/operating-manual/portal-overview/patient-dashboard.png";
import patientPageFrImg from "src/assets/images/operating-manual/portal-overview/patient-dashboard-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

const PatientPage = () => {
  const { t } = useTranslation("operating-manual");

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  const portalText = [
    {
      title: t("Navigation Bar"),
      content: t(
        "Navigate to the dashboard page, patient page, switch between clincs, view the operating manual, and view your profile options."
      ),
    },
    {
      title: t("Patient Section"),
      content: t(
        "Add, search, and select patients to create an exam for them or view their previous exams."
      ),
    },
    {
      title: t("Exam Section"),
      content: t("Add, select, and modify exams for the selected patient."),
    },
    {
      title: t("Device Section"),
      content: t(
        "View and manage devices. Each device has a name, exam status (linked / not linked to exam, and the name the exam is linked to), connection status (offline, online), and battery percentage."
      ),
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={currentLang === "fr" ? patientPageFrImg : patientPageImg}
          width="85%"
          alt="headset"
        />
      </Box>

      <Box
        sx={{
          padding: "20px",
          borderRadius: "8px",
          backgroundColor: "#5B6D7A30",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {portalText.map((portalItem, index) => (
            <Grid
              container
              key={portalItem.title}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Typography fontSize="14px" fontWeight={600}>
                {index + 1}. {portalItem.title}
              </Typography>
              <Typography fontSize="14px">{portalItem.content}</Typography>
            </Grid>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PatientPage;
